import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import Alert from '@/components/Alert/Alert';
import ChipsRadio from '@/components/chipsRadio/chipsRadio';
import FormTextError from '@/components/formTextError/formTextError';
import { STATUS } from '@/enums/status';

import styles from './styles.module.css';

interface TaxDeductionProps {
  isEligibleForTaxDeduction: boolean;
  isTaxDeductionSelected: boolean;
  didChooseDeduction: boolean;
  submitted: boolean;
  onSelectDeduction: (value: boolean) => void;
  onOpenInfoModal: () => void;
}

const TaxDeduction = ({
  isEligibleForTaxDeduction,
  isTaxDeductionSelected,
  didChooseDeduction,
  submitted,
  onSelectDeduction,
  onOpenInfoModal,
}: TaxDeductionProps) => {
  const { t } = useTranslation();

  if (!isEligibleForTaxDeduction) {
    return (
      <MtxGrid row>
        <MtxGrid className={styles.taxDeductionBox} col={12} colXs={12} colSm={12} colMd={12} colLg={8} colXl={12}>
          <div className={styles.taxDeductionBoxContainer}>
            <Alert status={STATUS.INFO} showIcon title={t('alert.title')} description={t('alert.description')} />
          </div>
        </MtxGrid>
      </MtxGrid>
    );
  }

  return (
    <div className={styles.taxDeductionBoxContainer}>
      <div className="scroll-anchor" id="faire-versement-anchor-deduction-fiscale" />
      <MtxGrid row>
        <MtxGrid className={styles.taxDeductionBox} col={12} colXs={12} colSm={12} colMd={12} colLg={12} colXl={12}>
          <p>
            {t('deposit.taxDeductionOptionLabel')}
            <button
              type="button"
              className={styles.taxDeductionInfoButton}
              onClick={onOpenInfoModal}
              aria-label="Informations sur la déduction fiscale"
            >
              <i className="totem-icon totem-icon-info" />
            </button>
          </p>
        </MtxGrid>
      </MtxGrid>

      <MtxGrid row className={styles.taxDeductionChips}>
        <MtxGrid col={2} colXs={6} colSm={3} colMd={3} colLg={2} colXl={2}>
          <ChipsRadio
            size="large"
            label="Oui"
            name="deductionFiscale"
            value="true"
            onChange={() => onSelectDeduction(true)}
            isChecked={isTaxDeductionSelected && didChooseDeduction}
          />
        </MtxGrid>

        <MtxGrid col={2} colXs={6} colSm={3} colMd={3} colLg={2} colXl={2}>
          <ChipsRadio
            size="large"
            label="Non"
            name="deductionFiscale"
            value="false"
            onChange={() => onSelectDeduction(false)}
            isChecked={!isTaxDeductionSelected && didChooseDeduction}
          />
        </MtxGrid>
      </MtxGrid>

      {submitted && !didChooseDeduction && <FormTextError text={t('deposit.errorTaxDeductionMessage')} />}
    </div>
  );
};

export default TaxDeduction;
